import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";

export const PO_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  pending_approval: { label: "Awaiting Approval", cls: "bg-amber-100 text-amber-800" },
  sent: { label: "Sent / On Order", cls: "bg-blue-100 text-blue-700" },
  partially_received: { label: "Partially Received", cls: "bg-indigo-100 text-indigo-700" },
  received: { label: "Received", cls: "bg-green-100 text-green-700" },
  cancelled: { label: "Cancelled", cls: "bg-red-100 text-red-700" },
};

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const PoStatusBadge = ({ status, overdue }) => (
  <span className="inline-flex items-center gap-1">
    <Badge className={`text-xs ${PO_STATUS[status]?.cls || ""}`} data-testid="po-status-badge">{PO_STATUS[status]?.label || status}</Badge>
    {overdue && <Badge className="text-xs bg-red-600 text-white" data-testid="po-overdue-badge">ETA overdue</Badge>}
  </span>
);

// Shared PO actions; `onDone` is called after any successful mutation.
export const usePoActions = (onDone) => {
  const send = async (po) => {
    try {
      const r = await axios.post(`${API}/procurement/lists/${po.po_id}/send`);
      if (r.status === 202) toast.info("Sent to owner for approval before it goes to the supplier");
      else toast.success(`${po.po_number} emailed to ${po.supplier_name}`);
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to send"); }
  };
  const duplicate = async (po) => {
    try {
      const r = await axios.post(`${API}/procurement/lists/${po.po_id}/duplicate`, {});
      toast.success(`Copied to ${r.data.po_number} (draft)`);
      onDone?.(r.data);
      return r.data;
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to duplicate"); }
  };
  const remove = async (po) => {
    const isDraft = ["draft", "pending_approval"].includes(po.status);
    if (!window.confirm(isDraft ? `Delete draft ${po.po_number}?` : `Cancel ${po.po_number}? The supplier will NOT be notified automatically.`)) return;
    try {
      const r = await axios.delete(`${API}/procurement/lists/${po.po_id}`);
      toast.success(r.data.message);
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const openPdf = (po) => window.open(`${API}/procurement/lists/${po.po_id}/pdf`, "_blank");
  return { send, duplicate, remove, openPdf };
};
